export class ClientInformation {
    constructor(
      public CLIENTID?: any,
      public DOB_DT?: any,
      public FIRST_NAME?: any,
      public GENDER_CD?: any,
      public LAST_NAME?: any,
      public MAILING_ADDR_CITY?: any,
      public MAILING_ADDR_LINE1?: any,
      public MAILING_ADDR_LINE2?: any,
      public MAILING_ADDR_STATE?: any,
      public MAILING_ADDR_ZIP?: any,
      public MESSAGE_PHONE?: any,
      public PRIMARY_LANGUAGE?: any,
      public RESIDENTIAL_ADDR_CITY?: any,
      public RESIDENTIAL_ADDR_LINE1?: any,
      public RESIDENTIAL_ADDR_LINE2?: any,
      public RESIDENTIAL_ADDR_STATE?: any,
      public RESIDENTIAL_ADDR_ZIP?: any,
      public RESIDENTIAL_COUNTY?: any,
      public RESIDENTIAL_PHONE?: any,
      public WORK_PHONE?: any,
      public CONVERSION_STAT?:any,
      public EMCI_ID?:any,
      public ERROR_CODE?:any,
      public ERROR_MESSAGE?:any
    ) {
    }
  }



// WEBPACK FOOTER //
// ./src/app/shared/model/client-information.ts